import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface TsoIdentificationState {
  tsoId: number | undefined;
  abbreviation: string | undefined;
}

const initialState: TsoIdentificationState = {
  tsoId: undefined,
  abbreviation: '',
};

const tsoIdentificationSlice = createSlice({
  name: 'tsoIdentification',
  initialState,
  reducers: {
    setTsoId: (state, action: PayloadAction<number | undefined>) => {
      state.tsoId = action.payload;
    },
    setTsoAbbreviation: (state, action: PayloadAction<string | undefined>) => {
      state.abbreviation = action.payload;
    },
  },
});

export const { setTsoId, setTsoAbbreviation } = tsoIdentificationSlice.actions;

export const selectTsoId = (state: { tsoIdentification: TsoIdentificationState }) => state.tsoIdentification.tsoId;
export const selectTsoAbbreviation = (state: { tsoIdentification: TsoIdentificationState }) =>
  state.tsoIdentification.abbreviation;

export default tsoIdentificationSlice.reducer;
